import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.cover}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700">
            {article.category}
          </span>
          <span className="text-xs text-foreground-500">{article.publishDate}</span>
        </div>
        <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200 leading-snug">
          {article.title}
        </h3>
        <p className="mt-2 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
          {article.summary}
        </p>
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.readCount >= 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
          </span>
          <span>{article.author}</span>
        </div>
      </div>
    </Link>
  );
}